import React from 'react';
import { Row } from 'antd';
import { Formik, Form as FormikForm, FormikHelpers } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './VerifyMFAOTP.module.scss';
import { VerifyMFAOTPEnums } from 'enums/VerifyMFAOTPEnums';
import {
    Fields,
    initialValues,
    validationSchema,
} from './VerifyMFAOTPConstants';

interface VerifyMFAOTPProps {
    email: string;
    onVerify: (otp: number) => Promise<void>;
    onResend: () => Promise<void>;
}

interface VerifyMFAOTPFormValues {
    otp: string;
}

const VerifyMFAOTP: React.FC<VerifyMFAOTPProps> = ({
    email,
    onVerify,
    onResend,
}: VerifyMFAOTPProps) => {
    const handleApiSubmission = async (values: VerifyMFAOTPFormValues) => {
        try {
            await onVerify(Number(values.otp));
        } catch (error) {
            console.log('Error verifying OTP:', error);
        }
    };

    const handleResendOTP = async (
        setFieldValue: FormikHelpers<VerifyMFAOTPFormValues>['setFieldValue']
    ) => {
        try {
            await onResend();
            setFieldValue('otp', '');
        } catch (error) {
            console.log('Error resending OTP:', error);
        }
    };

    return (
        <div className={styles.formContainer}>
            <Row className={styles.logoContainer}>
                <img
                    src={Logo}
                    alt={VerifyMFAOTPEnums.IMAGE_ALT}
                    className={styles.logo}
                />
            </Row>
            <Row className={styles.headingContainer}>
                <div>
                    <h1>{VerifyMFAOTPEnums.HEADING}</h1>
                </div>
                <div>
                    <h2>
                        {VerifyMFAOTPEnums.SUBHEADING} {email}
                    </h2>
                </div>
            </Row>
            <div className={styles.fieldsContainer}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={values => handleApiSubmission(values)}>
                    {formik => (
                        <FormikForm>
                            {Fields.map((field, index) => {
                                return (
                                    <div key={index} className={styles.fieldContainer}>
                                        <InputField
                                            name={field.name}
                                            placeholderstring={field.placeholder}
                                            maxLength={field.maxLength}
                                            label={field.label}
                                        />
                                        {field.helper && (
                                            <div className={styles.helpercontainer}>
                                                <p>
                                                    {VerifyMFAOTPEnums.HELPER_TEXT}{' '}
                                                    <span
                                                        className={styles.spanText}
                                                        onClick={() =>
                                                            handleResendOTP(formik.setFieldValue)
                                                        }>
                                                        {VerifyMFAOTPEnums.HELPER_TEXT_SPAN}
                                                    </span>
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}

                            <div className={styles.buttonContainer}>
                                <COButton
                                    loading={formik.isSubmitting}
                                    submit
                                    disabled={!formik.isValid}>
                                    {VerifyMFAOTPEnums.BUTTON_LABEL_SUBMIT}
                                </COButton>
                            </div>
                        </FormikForm>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default VerifyMFAOTP;

